import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="bg-black py-8 ">
        <div>
          <p className="text-center text-white font-dosis text-label-subtitle animated-bounce">
            {" "}
            Made by Ines Piazzese with React and Tailwind CSS
          </p>
        </div>
      </footer>
    </div>
  );
}
